import { useSelector } from 'react-redux';
import { isDocumentVaultReadonlySelector } from '../../CommonSelectors/CommonAreaSelector';

export const useIsDocumentVaultReadOnly = (): boolean => {
  return useSelector(isDocumentVaultReadonlySelector);
};
